import axios from "axios";
import { BaseUrl } from "./config"

export const getAllsContactsPagination = async (data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/contact/getAllContacts`, {
            params: data // Pasar data como parámetro de consulta
          });

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getContactByID = async ( id ) => {
    try {
        // Obtener el token de acceso
        console.log(id, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/contact/getContactById?id=${id}`);


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const updateContactById = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.put(`${BaseUrl}/contact/update`, data );


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}
export const updateContactClient = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.put(`${BaseUrl}/contact/updateContactClient`, data );


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}


export const createAsesor = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.post(`${BaseUrl}/users/register`, data );


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}


export const getAllsAsesores = async (data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/asesores/getAllAsesores`, {
            params: data // Pasar data como parámetro de consulta
          });

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getAsesorById = async ( id ) => {
    try {
        // Obtener el token de acceso
        console.log(id, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/asesores/getAsesorById?id=${id}`);


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}



export const getReporteActividadAsesor = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data,"getReporteActividadAsesor")
        const response = await axios.get(`${BaseUrl}/asesores/reporteActividadAsesor`,{
            params: data // Pasar data como parámetro de consulta
          });


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getReporteActividadAsesor2 = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data)
        console.log(data,"getReporteActividadAsesor")
        const response = await axios.get(`${BaseUrl}/asesores/reporteActividadAsesor2`,{
            params: data // Pasar data como parámetro de consulta
          });


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}
export const uploadToS3 = async ( formData ) => {
    try {
        // Obtener el token de acceso
        console.log(formData, "formData")
        const response = await  axios.post(`${BaseUrl}/aws/uploadPhoto`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getContactsGroups = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "data")
        const response = await  axios.get(`${BaseUrl}/contact/getAllContactGroups`, data)

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}


export const login = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "data")
        const response = await  axios.post(`${BaseUrl}/users/login`, data)

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const asignarContactos = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "data")
        const response = await  axios.post(`${BaseUrl}/contact/assignContactsToUser`, data)

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const removerContactos = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "data")
        const response = await  axios.post(`${BaseUrl}/contact/removeContactsFromUser`, data)

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const createProductor = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.post(`${BaseUrl}/users/register`, data );


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getAllsProductores = async (data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/productores/getProductores`, {
            params: data // Pasar data como parámetro de consulta
          });

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getProductorById = async (id) => {
    try {


        const response = await axios.get(`${BaseUrl}/productores/getProductoreById?id=${id}`);

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}


export const getAllSeguimientos = async (data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/seguimientos/getAllSeguimientos`, {
            params: data // Pasar data como parámetro de consulta
          });

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const createSeguimiento = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.post(`${BaseUrl}/seguimientos/createSeguimiento`, data );


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}
export const updateSeguimiento = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.put(`${BaseUrl}/seguimientos/updateSeguimiento`, data );


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}


export const createCliente = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.post(`${BaseUrl}/clientes/createCliente`, data );


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}
export const createClienteAux = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.post(`${BaseUrl}/clientes/createClienteAux`, data );


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getAllsClientes = async (data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/clientes/getAllClientes`, {
            params: data // Pasar data como parámetro de consulta
          });

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}
export const getClienteById = async ( id ) => {
    try {
        // Obtener el token de acceso
        console.log(id, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/clientes/getClienteById?id=${id}`);


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getAllsClientesByProductorId = async (data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/productores/getAllClientesByProductorId`, {
            params: data // Pasar data como parámetro de consulta
          });

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getAllContactsByProductorId = async (data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/productores/getAllContactsByProductorId`, {
            params: data // Pasar data como parámetro de consulta
          });

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}
export const createEvent = async ( data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.post(`${BaseUrl}/eventos/createEvento`, data );


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getEventsById = async ( id ) => {
    try {
        // Obtener el token de acceso
        console.log(id, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/eventos/getEventosByUserId?id=${id}`);


        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const createOrganizacion = async ( data ) => {
    try {
        console.log(data, "ENDPOINTS")
        const response = await axios.post(`${BaseUrl}/organizaciones/createOrganizacion`, data );
        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response
    }   
}
export const deleteOrganizacion = async ( data ) => {
    try {
        console.log(data, "ENDPOINTS")
        const response = await axios.put(`${BaseUrl}/organizaciones/deleteOrganizacion`, data );
        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response
    }   
}

export const updateOrganizacionById = async ( data ) => {
    try {
        console.log(data, "ENDPOINTS")
        const response = await axios.put(`${BaseUrl}/organizaciones/updateOrganizacionById`, data );
        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response
    }   
}




export const getAllOrganizaciones = async (data ) => {
    try {
        // Obtener el token de acceso
        console.log(data, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/organizaciones/getAllOrganizaciones`, {
            params: data // Pasar data como parámetro de consulta
          });

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

        // throw error; // Re-lanzar el error para que el controlador o middleware lo maneje
    }   
}

export const getOrganizacionById = async (data ) => {
    try {

        console.log(data, "ENDPOINTS")
        const response = await axios.get(`${BaseUrl}/organizaciones/getOrganizacionById`, {
            params: data // Pasar data como parámetro de consulta
          });

        if (response?.status === 200) {
            return response
        } else {
            return response;
        }
    } catch (error) {
                console.error('Error al realizar la solicitud:', error);
        return error.response

    }   
}